import { render, staticRenderFns } from "./inputJenisEmas.vue?vue&type=template&id=bc9904e2&"
import script from "./inputJenisEmas.vue?vue&type=script&lang=js&"
export * from "./inputJenisEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports